export default __webpack_public_path__ + "media/images/instagram-ec7cfbd6c39847c6b7e3370a5eeba786.svg";